import { useContext } from 'react';
import { graphql } from 'gatsby'
import { I18nextContext } from 'gatsby-plugin-react-i18next'
import { JsonLd } from 'react-schemaorg'
import { Brand } from 'schema-dts'

import Layout from '../../../../components/layout'
import Seo from '../../../../components/seo'
import BuyingHeroFilter from '../../../../components/BuyingHero/BuyingHeroFilter'
import Contact from '../../../../components/Contact'
import Benefits from '../../../../components/Benefits'
import MagazineTeaser from '../../../../components/MagazineTeaser'
import MagazineArticle from '../../../../components/MagazineArticle'
import { BUYING_CATALOG_ROUTE, CONTACT_ROUTE } from '../../../../utils/routes/const';

type BrandCatalogProps = {
  data: {
    brand: WatchProject21Api.Brand
  }
}

const BrandCatalogPage = ({ data }: BrandCatalogProps) => {
  const { brand } = data;
  const { language } = useContext(I18nextContext);

  const catalogTitle = brand[`catalogTitle${language.toUpperCase() || 'ES'}`];
  const catalogDescription = brand[`catalogDescription${language.toUpperCase() || 'ES'}`] || brand?.magazine?.subTitle || '';

  return (
    <Layout bgColor='bg-gray' footerColor='bg-gray'>
      <Seo title={`${brand.name} - Catalog `} />
      <JsonLd<Brand>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Brand',
          name: brand?.name,
          url: `https://watchproject21.com${BUYING_CATALOG_ROUTE(brand?.slug)}`,
          description: catalogDescription,
        }}
      />
      <BuyingHeroFilter
        bgColorHero='bg-gray'
        title={catalogTitle}
        description={catalogDescription}
        brand={brand.name}
      />
      <Contact
        title='catalog.brand.contact.title'
        cta='buy.contact.cta'
        url={CONTACT_ROUTE}
      />
      <Benefits type='buy' />
      {brand.magazine && <MagazineArticle magazine={brand.magazine} />}
      <MagazineTeaser />
    </Layout>
  )
}

export default BrandCatalogPage

export async function config() {
  return () => ({
    defer: true,
  })
}


export const query = graphql`
  query($language: String!, $slug: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    brand: brand(slug: {eq: $slug}) {
      name
      catalogDescriptionEN
      catalogDescriptionES
      catalogTitleEN
      catalogTitleES
      magazine {
        title
        subTitle
        topText
        topImage
        middleText
        middleImage
        bottomText
        bottomImage
        createdAt
      }
    }
  }
`
